namespace GeniuzPOS.Inventory {
    export interface IcParaRow {
        Id?: number;
        IcFg?: string;
        Stkmedthod?: string;
        PostSequenceFg?: PostSequenceFgstatus;
        Cus_CostCenter?: string;
        Cus_ProfitCenter?: string;
    }

    export namespace IcParaRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Id';
        export const localTextPrefix = 'Inventory.IcPara';
        export const lookupKey = 'Inventory.IcPara';

        export function getLookup(): Q.Lookup<IcParaRow> {
            return Q.getLookup<IcParaRow>('Inventory.IcPara');
        }
        export const deletePermission = '2Inventory:ระบบ:ตั้งค่าเริ่มต้นระบบสต๊อก:Modify';
        export const insertPermission = '2Inventory:ระบบ:ตั้งค่าเริ่มต้นระบบสต๊อก:Modify';
        export const readPermission = '2Inventory:ระบบ:ตั้งค่าเริ่มต้นระบบสต๊อก:View';
        export const updatePermission = '2Inventory:ระบบ:ตั้งค่าเริ่มต้นระบบสต๊อก:Modify';

        export declare const enum Fields {
            Id = "Id",
            IcFg = "IcFg",
            Stkmedthod = "Stkmedthod",
            PostSequenceFg = "PostSequenceFg",
            Cus_CostCenter = "Cus_CostCenter",
            Cus_ProfitCenter = "Cus_ProfitCenter"
        }
    }
}
